import Vue from "vue";
// @ts-ignore because there are no definitions for the locales
import nl from "vee-validate/dist/locale/nl";
import VeeValidate, { Validator } from "vee-validate";

export default (): void => {
  Validator.localize("nl", nl);
  Vue.use(VeeValidate, {
    locale: "nl"
  });
};
